import React, { useContext, useEffect, useState } from 'react';
import {FormDataContext} from "../../contexts/FormDataContext";
import { SectionHeading } from '../SectionHeading';
import { IntakeAutocomplete } from '../IntakeAutocomplete';

export const EducationAutocomplete = () => {
  const [educationOptions, setEducationOptions] = useState([]);
  const {
    selectedDegrees,
    setSelectedDegrees,
    preferencesFormDisabled,
    degrees,
  } = useContext(FormDataContext);

  useEffect(() => {
    setEducationOptions(
      Object.entries(degrees).map(([key, label]) => {
        return {id: key, name: label}
      })
    );
  }, [degrees]);

  return (
    <>
      <SectionHeading>
        Education Level
      </SectionHeading>
      {educationOptions.length > 0 &&
        <IntakeAutocomplete
          options={educationOptions}
          selectedTaxonomyTermIds={selectedDegrees}
          setSelectedTaxonomyTermIds={setSelectedDegrees}
          label="education level"
          disabled={preferencesFormDisabled}
        />
      }
    </>
  );
};
